<template>
    <v-hover v-slot="{ hover }">
        <v-card
            :width="width"
            class="vehicle-card d-flex flex-column"
            :class="[cardClass, { 'vehicle-card--hover': hover }]"
            :to="{ name: 'item', params: { id: item.id } }"
        >
            <v-img
                :height="imageHeight"
                :src="photo"
                gradient="to top, rgba(0,0,0,0.2), rgba(0,0,0,0.01)"
            >
                <v-container
                    v-if="!item.sold_at"
                    fluid fill-height align-start justify-end
                    style="position: absolute;"
                >
                    <v-chip
                        label color="primary" dark
                        class="title font-weight-bold secondary--text"
                    >
                        {{ _formatMoney(item.price) }}
                    </v-chip>
                </v-container>
                <v-container
                    v-else
                    fluid fill-height align-center justify-center
                    style="position: absolute;"
                >
                    <v-chip
                        label x-large color="error" dark
                        class="display-1 sold"
                    >
                        <v-icon left size="40">mdi-check</v-icon>VENDU
                    </v-chip>
                </v-container>
                <v-container
                    fluid fill-height align-end justify-end
                    style="position: absolute;"
                >
                    <v-chip
                        label color="secondary" dark
                        class="font-weight-bold primary--text"
                    >
                        {{ _formatKilometrage(item.kilometrage) }}
                    </v-chip>
                </v-container>
            </v-img>
            <v-card-title class="pb-2 vehicle-card-title">
                {{ item.brand }} {{ item.model }}
            </v-card-title>
            <v-card-subtitle class="pt-1 pb-3">
                {{ item.year }}<span v-if="item.model_description"> · {{ item.model_description }}</span>
            </v-card-subtitle>
            <v-card-text class="pt-0 flex-grow-1">
                <v-chip-group column>
                    <v-chip small color="grey lighten-3">{{ item.color }}</v-chip>
                    <v-chip small color="grey lighten-3">{{ _formatKilometrage(item.kilometrage) }}</v-chip>
                    <v-chip small color="grey lighten-3">{{ item.transmission }}</v-chip>
                </v-chip-group>
            </v-card-text>
            <v-card-actions class="pt-0 px-4 pb-4">
                <div class="vehicle-card-action primary--text font-weight-bold text-center">
                    Voir le véhicule
                    <v-icon right color="primary">mdi-arrow-right</v-icon>
                </div>
            </v-card-actions>
        </v-card>
    </v-hover>
</template>

<script>
    export default {
        name: "vehicle-card",
        props: {
            item: {
                type: Object,
                required: true
            },
            width: {
                type: [String, Number],
                default: "100%"
            },
            cardClass: {
                type: String,
                default: "my-3"
            },
            imageHeight: {
                type: [String, Number],
                default: 230
            }
        },
        computed: {
            photo() {
                return this.item.photo_url || (this.item.photo ? "/uploads/" + this.item.photo : require("./../../assets/img/coming-soon.png"));
            }
        }
    };
</script>

<style scoped>
    .vehicle-card {
        overflow: hidden;
        border-radius: 8px;
        transition: transform 180ms ease, box-shadow 180ms ease;
    }

    .vehicle-card--hover {
        transform: translateY(-5px);
    }

    .vehicle-card-title {
        line-height: 1.25;
        word-break: normal;
    }

    .vehicle-card-action {
        width: 100%;
    }

    .sold {
        margin-top: 50px;
        transform-origin: 0 0;
        transform: rotate(-20deg);
        opacity: 0.7;
    }
</style>
